import { Settings } from "@redotech/redo-model/team";

export const allowCustomerAccounts = (
  email: string | undefined,
  customerAccountSettings: Settings["customerAccounts"],
) => {
  return (
    !!email?.endsWith("@getredo.com") && !!customerAccountSettings?.enabled
  );
};
